<!-- Content -->
<mat-dialog-content>
	<!-- Logotype -->
	<div direction="column" vertical="center" class="slds-m-bottom--large">
		<eff-icon name="eff-logo-black" size="auto" class="ds-subscription-renewal__logotype" />
	</div>
	<!-- / Logotype -->

	<!-- Header Text -->
	<header dsTestId="header" class="slds-m-bottom--x-small ds-subscription-renewal__header">
		@if (isLicensed) {
			Your subscription will end {{ duration }}
		} @else {
			Your subscription has ended.
		}
	</header>
	<!-- / Header Text -->

	<!-- Description -->
	<div class="ds-subscription-renewal__description">
		<div>Resubscribe to continue enjoying all the features</div>
		<div>of efficiently.</div>
	</div>
	<!-- / Description -->
</mat-dialog-content>
<!-- / Content -->

<!-- Actions -->
<mat-dialog-actions horizontal="center">
	<!-- Continue -->
	<button type="button" mat-stroked-button color="secondary" (click)="handleContinue()" class="ds-button--md">
		<span>Continue</span>
	</button>
	<!-- / Continue -->

	<!-- Resubscribe -->
	<button type="button" mat-raised-button color="primary" (click)="handleOpenBilling()" class="ds-button--md">
		Resubscribe
	</button>
	<!-- / Resubscribe -->
</mat-dialog-actions>
<!-- / Actions -->
